import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';

import { Provider } from 'react-redux';
import store from './redux/appStore/store';
import { ErrorProvider } from './context/ErrorContext';
import Context from './context/Context';
const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.NODE_ENV === "production") {
  console = {
    ...console,
    log: () => {},
    warn: () => {},
    error: () => {},
    info: () => {},
    debug: () => {},
  };
}
root.render(
  <Provider store={store}>
    <ErrorProvider>
      <Context>
        <App />
      </Context>
    </ErrorProvider>
  </Provider>
);
